export const supportedStrapMaterials = [
  'Alligator leather & rubber',
  'Alligator leather',
  'Calfskin leather',
  'ECONYL® yarn',
  'Rubber',
  'Polyamide fabric',
  'Stainless steel',
  '18k red gold',
  'Stainless steel & 18k red gold',
  'Stainless steel & 18k rose gold',
  'Titanium',
  'DLC-coated titanium',
  'Calfskin leather & rubber',
  'Alligator leather & rubber',
] as const;

type SupportedStrapMaterial = (typeof supportedStrapMaterials)[number];

export const strapMaterials = {
  alligator: 'alligator',
  fabric: 'fabric',
  leather: 'leather',
  rubber: 'rubber',
  metal: 'metal',
  other: 'other',
};

export const getStrapMaterial = (material: SupportedStrapMaterial | string) => {
  //TODO check unsupport strap material
  switch (material) {
    case 'Alligator leather': {
      return strapMaterials.alligator;
    }
    case 'ECONYL® yarn': {
      return strapMaterials.fabric;
    }
    case 'Polyamide fabric': {
      return strapMaterials.fabric;
    }
    case 'Calfskin leather': {
      return strapMaterials.leather;
    }
    case 'Alligator leather & rubber': {
      return strapMaterials.rubber;
    }
    case 'Rubber': {
      return strapMaterials.rubber;
    }
    case 'Stainless steel': {
      return strapMaterials.metal;
    }
    case '18k red gold': {
      return strapMaterials.metal;
    }
    case 'Stainless steel & 18k red gold': {
      return strapMaterials.metal;
    }
    case 'Stainless steel & 18k rose gold': {
      return strapMaterials.metal;
    }
    case 'Titanium': {
      return strapMaterials.metal;
    }
    case 'DLC-coated titanium': {
      return strapMaterials.metal;
    }
    case 'Calfskin leather & rubber': {
      return strapMaterials.rubber;
    }
    default: {
      return strapMaterials.other;
    }
  }
};

//TODO How to filter when language not english
export const isSupportedStrapMaterial = (material: string) => {
  return (supportedStrapMaterials as ReadonlyArray<string>)?.includes(material);
};
